// src/pages/AddFriendsPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserList from '../components/UserList';
import './AddFriendsPage.css';

const AddFriendsPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="add-friends-container">
      <header className="add-friends-header">
        <h2>Add Friends</h2>
      </header>
      <main className="add-friends-body">
        <UserList />
      </main>
      <footer className="add-friends-footer">
        <button onClick={() => navigate('/home')}>Back to Home</button>
      </footer>
    </div>
  );
};

export default AddFriendsPage;
